import Content from "./Content";

export default class AllegationContent extends Content {
    constructor(languagePack, contentID, titleText, descriptionText, label) {
        super(AllegationContent.NAME, AllegationContent.TYPE, label, languagePack, contentID);

        this.setTitleText(titleText);
        this.setDescriptionText(descriptionText);
    }

    setTitleText(value) {
        if (this.getTitleText() !== value) {
            this.setLanguagePackText(AllegationContent.TITLE_LABEL, value);
        }
    }

    getTitleText() {
        return this.getLanguagePackText(AllegationContent.TITLE_LABEL);
    }

    setDescriptionText(value) {
        if (this.getDescriptionText() !== value) {
            this.setLanguagePackText(AllegationContent.DESCRIPTION_LABEL, value);
        }
    }

    getDescriptionText() {
        return this.getLanguagePackText(AllegationContent.DESCRIPTION_LABEL);
    }

    convertToObject() {
        return this.getObject([]);
    }
}

AllegationContent.NAME = "Allegation";
AllegationContent.TYPE = "engAllegationContent";
AllegationContent.TITLE_LABEL = "title";
AllegationContent.DESCRIPTION_LABEL = "description";
